<template>
  <div class="breadcrumbs">
    <template v-for="(crumb, i) in items">
      <span
        v-if="i > 0"
        :key="`${i} - ${crumb.name}`"
        >&gt;</span
      >
      <router-link
        v-if="crumb.url"
        :key="`crumb-link-${i}`"
        :to="crumb.url"
        class="crumb">
        <span>{{ crumb.name }}</span>
      </router-link>
      <span
        v-else
        :key="`crumb-${i}`"
        class="crumb"
        >{{ crumb.name }}</span
      >
    </template>
  </div>
</template>

<script>
  export default {
    props: ['items'],
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  #app .breadcrumbs {
    background: var(--breadcrumbsBackgroundColor);
    color: var(--breadcrumbsForegroundColor);
    border-bottom: 0.4rem solid var(--breadcrumbsBackgroundColorDark);

    width: 100%;
    padding: 0.8rem 0 0.8rem 1.2rem;
    font-size: 1.2rem;
    z-index: 1;
    top: 6.4rem;
    .crumb {
      padding: 0 0.4rem;
    }
    a {
      color: var(--breadcrumbsForegroundColor);

      cursor: pointer;
      font-weight: 700;
    }
  }
</style>
